import { StoreContext } from '../context/Store.context';

export const StoreProvider = StoreContext.Provider;
